export function formatNumber(value: number): string {
  if (value >= 1000 && value < 1000000) {
    return (value / 1000).toFixed(2) + "k";
  } else if (value >= 1000000 && value < 1000000000) {
    return (value / 1000000).toFixed(2) + "M";
  } else if (value >= 1000000000) {
    return (value / 1000000000).toFixed(2) + "B";
  } else {
    return value.toString();
  }
}
